import React, { useMemo } from 'react';
import { Box, Typography, FormControl, FormLabel, FormControlLabel, Checkbox, FormHelperText, Tooltip } from '@mui/material';
import LockRoundedIcon from '@mui/icons-material/LockRounded';

export const DocumentosCheckboxes = React.memo(({ documentosState, handleCheckboxChange, error, monedaTipo, requiereFacturaAntesPago, documentos, lockedByFile = {} }) => {
  const docsFiltrados = useMemo(() => {
    return documentos.filter(({ name }) => {
      if (name === 'cartaBancariamx' || name === 'estadoCuentamx') return monedaTipo === 'MXN';
      if (name === 'cartaBancariaus' || name === 'estadoCuentaus') return monedaTipo === 'USD';
      return true;
    });
  }, [monedaTipo, documentos]);

  return (
    <>
      <FormLabel component="legend" sx={{ mb: 0.75, color: 'text.secondary', fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase' }}>
        Checklist
      </FormLabel>
      <FormControl component="fieldset" fullWidth error={Boolean(error)}>
        <Box
          display="flex"
          flexWrap="wrap"
          gap={0.6}
          sx={{ '& > *': { width: { xs: '100%', sm: '48%', md: '32%' } } }}
        >
          {docsFiltrados.map(({ name, label }) => {
            const checked = !!documentosState[name];
            // Locked because a file was uploaded that controls this checkbox
            const isDisabled = Boolean(lockedByFile[name]);

            const tooltipTitle = isDisabled
              ? 'Este campo se marcó automáticamente al adjuntar el archivo correspondiente'
              : '';

            return (
              <Tooltip key={name} title={tooltipTitle} arrow disableHoverListener={!isDisabled}>
                <span>
                  <Box
                    sx={{
                      borderRadius: 1.25,
                      px: 0.65,
                      py: 0.05,
                      display: 'flex',
                      alignItems: 'center',
                      minHeight: 28,
                      border: '1px solid',
                      borderColor: checked ? 'primary.main' : 'divider',
                      backgroundColor: checked ? 'rgba(6, 85, 165, 0.06)' : '#fff',
                      transition: 'all .2s',
                      opacity: isDisabled ? 0.85 : 1,
                      cursor: isDisabled ? 'not-allowed' : 'default',
                      '& .MuiFormControlLabel-root': { mr: 0, width: '100%' },
                      '& .MuiFormControlLabel-label': { minWidth: 0, flex: 1 },
                      '& .MuiCheckbox-root': { p: 0.35, mr: 0.2 },
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={name}
                          checked={checked}
                          onChange={handleCheckboxChange}
                          size="small"
                          disabled={isDisabled}
                        />
                      }
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="body2" noWrap title={label} sx={{ fontSize: '0.74rem', fontWeight: checked ? 700 : 500 }}>{label}</Typography>
                          {isDisabled && <LockRoundedIcon sx={{ fontSize: 12, color: 'primary.main', opacity: 0.7 }} />}
                        </Box>
                      }
                    />
                  </Box>
                </span>
              </Tooltip>
            );
          })}
        </Box>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </>
  );
});
